import { AddressForm, FormInput } from 'components/molecules';
import LabelFormStep from 'components/templates/label-form-step/LabelFormStep';
import { useTranslation } from 'react-i18next';

const LabelTaxAddressStep = () => {
  const { t } = useTranslation();
  return (
    <LabelFormStep
      header={t('label.form.tax-office.header')}
      description={t('label.form.tax-office.description')}>
      <AddressForm
        topContent={
          <FormInput.Text
            name={`taxOffice.name`}
            label={t('input.label.name')}
            fullWidth
            borderless
            appBackground
          />
        }
        propertyPrefix='taxOffice.'
      />
    </LabelFormStep>
  );
};

export default LabelTaxAddressStep;
